import React from "react";

const CHUNK_ERROR_PATTERNS = [
  /Loading chunk \d+ failed/i,
  /ChunkLoadError/i,
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
];

export const isChunkLoadError = (error) => {
  const name = error?.name || "";
  const message = error?.message || String(error || "");

  return CHUNK_ERROR_PATTERNS.some(
    (pattern) => pattern.test(name) || pattern.test(message)
  );
};

export class ChunkLoadErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { chunkLoadFailed: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      return { chunkLoadFailed: true };
    }

    throw error;
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) {
      throw error;
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.chunkLoadFailed) {
      return (
        <div className="loader-overlay chunk-load-fallback" role="alert">
          <p>Učitavamo novu verziju aplikacije.</p>
          <button type="button" className="purple-button" onClick={this.handleReload}>
            Osveži stranicu
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkLoadErrorBoundary;
